// extracted by mini-css-extract-plugin
module.exports = {"promoCode":"CharterPage_promoCode__1qw7z","description":"CharterPage_description__3_CY_","code":"CharterPage_code__1xllj","discount":"CharterPage_discount__117dm"};